__turbopack_context__.v({
  "className": "figtree_454e5d61-module__BDZd1W__className",
  "variable": "figtree_454e5d61-module__BDZd1W__variable",
});
